<template>
    <Slider
        ref="sliderComponent"
        class="banner-scrubbar"
        :min="0"
        :max="duration"
        :step="0.01"
        :model-value="modelValue"
        :tip-format="formatLabel"
        @onInput="onInput"
        @onChange="onChange"
    />
</template>

<script lang="ts">
import Slider from "view-ui-plus";

type SliderType = typeof Slider;

type CustomSlider = SliderType & {
    onPointerDragStart: (event: PointerEvent) => void;
    onPointerDrag: (event: PointerEvent) => void;
    onPointerDragEnd: (event: PointerEvent) => void;
};

export default {
    name: "BannerScrubbar",
    props: {
        duration: {
            type: Number,
            required: true
        },

        modelValue: {
            type: Number,
            default: 0
        }
    },

    emits: ["update"],

    data() {
        return {
            dragging: false,
            onPointerDragStart: null as null | ((event: PointerEvent) => void),
            onPointerDrag: null as null | ((event: PointerEvent) => void),
            onPointerDragEnd: null as null | ((event: PointerEvent) => void)
        };
    },

    mounted() {
        const sliderComponent = this.$refs.sliderComponent as CustomSlider;

        this.onPointerDragStart = sliderComponent.onPointerDragStart;
        this.onPointerDrag = sliderComponent.onPointerDrag;
        this.onPointerDragEnd = sliderComponent.onPointerDragEnd;

        // we need to hack that in because the component does not return the info for us nor we can watch internal prop
        sliderComponent.onPointerDragStart = event => {
            this.onPointerDragStart?.(event);
            this.dragging = true;
        };

        sliderComponent.onPointerDragEnd = event => {
            this.onPointerDragEnd?.(event);
            this.dragging = false;
        };
    },

    methods: {
        formatLabel(val: number) {
            return `${val} Sec`;
        },

        onChange(val: number) {
            this.$emit("update", val);
        },

        onInput(val: number) {
            if (this.dragging) {
                this.$emit("update", val);
            }
        }
    }
};
</script>

<style lang="scss">
.banner-scrubbar.ivu-slider {
    padding: 0 8px;

    .ivu-slider-button {
        width: 18px;
        height: 18px;

        .ivu-slider-wrap {
            width: 40px;
            height: 40px;
            top: -6px;
        }
    }
}
</style>
